/*
 * @Author: 孙照
 * @LastEditTime: 2024-01-04 14:26:18
 * @Description: vuex 总览模块
 * @FilePath: \sheyang\src\store\modules\overView.js
 */
import {
  getPowerStatData,
  getMonthAnalyseData,
  getStationDetail,
} from '@/api/overView/index';
import { getYesterdayOrTodayCharging } from '@/api/stationStatistics/index';
import { getTime, toDecimal, sum } from '@/utils/index';

const GET_POWER_STAT_DATA = 'getPowerStatData';
const GET_PV_STATS = 'getPvStats';
const GET_MONTH_ANY_DATA = 'getMonthAnalyseData';
const GET_PV_POWER_STAT_DATA = 'getPvPowerStatData';
const GET_TOTAL_PV_POWER = 'getTotalPvPower';
const GET_MONTH_CHARGING_POWER_DATA = 'getMonthChargingPowerData'; // 月累计用电量
const GET_MONTTH_DISCHARGING_POWER_DATA = 'getMonthDisChargingPowerData'; // 月累计放电量
const GET_PV_POWER_GENERATION = 'getPvPowerGeneration';
const GET_PV_EQUIPMENT_LIST = 'getPvEquipmentList';
const GET_PV_STATION = 'getPvStation';
const GET_PV_STATION_TODAT = 'getPvStationTodat';
const GET_DATA_STATITISTICS = 'getDataStatistics';
const GET_CHARGING_INFO = 'getChargingInfo';
const GET_OVERVIEW_CARD_DATA = 'getOverViewCardData'; // 获取总览卡片数据
const GET_CHARGING_CARD_DATA = 'getChargingCardData'; // 获取充电卡片数据
const GET_PV_CARD_DATA = 'getPvCardData'; // 获取光伏卡片数据
const GET_STORAGE_CARD_DATA = 'getStorageCardData'; // 获取储能卡片数据

const overView = {
  namespaced: true,
  state: () => ({
    // 总览数据
    powerStatData: {
      chargingAmount: 0, // 累计充电量
      chargeAmount: 0, // 累计充电次数
      pvPowerGeneration: 0, // 累计光伏发电量
      storedChargingAmount: 0, // 累计储能充电量
      storedDisChargingAmount: 0, // 累计储能放电量
      reduction: 0, // 累计碳减排
      chargingFee: 0, // 累计充电收入
      electricInternalTod: 0, // 今日充电总量
      electricInternalTodYesterday: 0, // 昨日充电总量
      todayChargeCnt: 0, // 今日充电次数
      todayFee: 0, // 今日订单金额
    },
    pvStats: {
      rankList: [], // top 10 充电数据
      todayDegree: 0, // 今日充电量
      yesterdayDegree: 0, // 昨日充电量
    }, // 光伏相关
    monthAnysDate: [], // 近一个月趋势分析 日期
    monthPvPowerData: [], // 近一个月光伏发电量
    monthChargingPowerData: [], // 月累计用电量
    monthDisChargingPowerData: [], // 月累计放电量
    totalPvPower: 0, // 总光伏发电量
    pvPowerGeneration: [], // 近30天光伏发电量
    pvEquipmentList: [], // 电站光伏设备列表
    pvStation: {}, // 弹框里左上部分（光伏，储能）
    pvStationTodat: {}, // 弹框的峰谷,功率，电量 （光伏，储能）
    dataStatistics: {}, // 弹框的总发电量 （光伏，储能）
    chargingInfo: {},
    overViewCardData: {}, // 总览卡片数据
    chargingCardData: {}, // 充电卡片数据
    pvCardData: {}, // 光伏卡片数据
    storageCardData: {}, // 储能卡片数据
    stationDegreeInfo: {
      todayDegree: 0, // 今日充电量
      yesterdayDegree: 0, // 昨日充电量
    }, // 单点站度数信息
    stationTableData: [], // 电站滚动列表数据
  }),
  mutations: {
    // 头部充电总览数据
    [GET_POWER_STAT_DATA]: (state, commit) => {
      state.powerStatData = { ...commit };
    },
    [GET_PV_STATS]: (state, commit) => {
      state.pvStats = { ...commit };
    },
    // 月x轴坐标数据
    [GET_MONTH_ANY_DATA]: (state, commit) => {
      state.monthAnysDate = [...commit];
    },
    // 近30日光伏发电量
    [GET_PV_POWER_GENERATION]: (state, commit) => {
      state.pvPowerGeneration = [...commit];
    },
    // 近一个月光伏发电量
    [GET_PV_POWER_STAT_DATA]: (state, commit) => {
      state.monthPvPowerData = [...commit];
    },
    // 总光伏发电量
    [GET_TOTAL_PV_POWER]: (state, commit) => {
      state.totalPvPower = commit;
    },
    // 月累计用电量
    [GET_MONTH_CHARGING_POWER_DATA]: (state, commit) => {
      state.monthChargingPowerData = [...commit];
    },
    // 月累计放电量
    [GET_MONTTH_DISCHARGING_POWER_DATA]: (state, commit) => {
      state.monthDisChargingPowerData = [...commit];
    },
    // 电站光伏设备列表
    [GET_PV_EQUIPMENT_LIST]: (state, commit) => {
      state.pvEquipmentList = [...commit];
    },
    // 弹框里左上部分（光伏，储能）
    [GET_PV_STATION]: (state, commit) => {
      state.pvStation = { ...commit };
    },
    // 弹框的峰谷,功率，电量 （光伏，储能）
    [GET_PV_STATION_TODAT]: (state, commit) => {
      state.pvStationTodat = { ...commit };
    },
    // 弹框的总发电量 （光伏，储能）
    [GET_DATA_STATITISTICS]: (state, commit) => {
      state.dataStatistics = { ...commit };
    },
    // 充电信息
    [GET_CHARGING_INFO]: (state, commit) => {
      state.chargingInfo = { ...commit };
    },
    // 获取总览卡片数据
    [GET_OVERVIEW_CARD_DATA]: (state, commit) => {
      state.overViewCardData = { ...commit };
    },
    // 获取充电卡片数据
    [GET_CHARGING_CARD_DATA]: (state, commit) => {
      state.chargingCardData = { ...commit };
    },
    // 获取光伏卡片数据
    [GET_PV_CARD_DATA]: (state, commit) => {
      state.pvCardData = { ...commit };
    },
    // 获取储能卡片数据
    [GET_STORAGE_CARD_DATA]: (state, commit) => {
      state.storageCardData = { ...commit };
    },
  },
  actions: {
    // 获取总览概况数据(累计发电量等)
    async getOverViewPowerStatData (context) {
      const res = await getPowerStatData();
      const { code, data } = res;
      if (code === '200' && data) {
        if (Object.keys(data).length > 0) {
          Object.keys(data).forEach((v) => {
            data[v] = Number(data[v]);
            if (v === 'pvPowerGeneration') {
              data[v] = toDecimal(data[v] / 1000, 1);
            }
          });
          context.commit(GET_POWER_STAT_DATA, data);
        }
      }
    },
    // 近一月趋势分析
    async getOverViewMonthAnalyseData (context) {
      const res = await getMonthAnalyseData();
      const { code, data } = res;
      if (code === '200' && data) {
        // 日期格式化
        const monthAnysDate = []; // 月x轴坐标数据
        const monthPvPowerData = []; // 近一个月光伏发电量
        const monthChargingPowerData = []; // 月累计用电量
        const monthDisChargingPowerData = []; // 月累计放电量
        const pvPowerGeneration = [];
        const storedChargingAmount = [];
        const storedDisChargingAmount = [];
        data.forEach((v) => {
          monthAnysDate.push(getTime(v.date * 1000, 'month-date'));
          monthPvPowerData.push(v.pvPowerGeneration);
          monthChargingPowerData.push(v.power);
          monthDisChargingPowerData.push(v.storedDisChargingAmount);
          pvPowerGeneration.push(v.pvPowerGeneration);
          storedChargingAmount.push(v.storedChargingAmount);
          storedDisChargingAmount.push(v.storedDisChargingAmount);
        });
        const chargingInfo = {
          storedDisChargingAmount,
          storedChargingAmount,
        };
        const totalPvPower = toDecimal(sum(monthPvPowerData));
        context.commit(GET_MONTH_ANY_DATA, monthAnysDate);
        context.commit(GET_PV_POWER_STAT_DATA, monthPvPowerData);
        context.commit(GET_TOTAL_PV_POWER, totalPvPower);
        context.commit(GET_MONTH_CHARGING_POWER_DATA, monthChargingPowerData);
        context.commit(GET_MONTTH_DISCHARGING_POWER_DATA, monthDisChargingPowerData);
        context.commit(GET_PV_POWER_GENERATION, pvPowerGeneration);
        context.commit(GET_CHARGING_INFO, chargingInfo);
      }
    },
    // 获取充电TOP10，今日昨日充电量
    async rankAndYesterdayOrTodayData (context) {
      const res = await getYesterdayOrTodayCharging();
      const { code, data } = res;
      let rankData = [];
      if (code === '200' && data) {
        const {
          rankingType,
          chargingDegrees,
          yesterdayDegrees,
          pvPowerGenerationF,
          pvPowerGenerationG,
          pvPowerGenerationJ,
          pvPowerGenerationP,
        } = data;
        if (rankingType && rankingType.length > 0) {
          rankData = rankingType.map((v) => ({
            ...v,
            chargeCountRate: toDecimal(v.chargeCountRate * 100, 2),
            chargeCount: toDecimal(v.chargeCount, 2),
          }));
        }

        const pvStats = {
          rankList: [...rankData],
          chargingDegrees: toDecimal(chargingDegrees),
          yesterdayDegrees: toDecimal(yesterdayDegrees),
          pvPowerGenerationTotal: pvPowerGenerationF + pvPowerGenerationG + pvPowerGenerationJ + pvPowerGenerationP,
          storedChargingAmountTotal: (data.storedChargingAmountF + data.storedChargingAmountG + data.storedChargingAmountP + data.storedChargingAmountJ) || 0,
          storedDisChargingAmountTotal: (data.storedDisChargingAmountF + data.storedDisChargingAmountG + data.storedDisChargingAmountP + data.storedDisChargingAmountJ) || 0,
          ...data,
        };
        context.commit(GET_PV_STATS, pvStats); // 光伏相关
      }
    },
    // 电站地图电站监控
    async stubGroupQry (context, stubGroupId) {
      const res = await getStationDetail({
        stubGroupId,
      });
      const { code, data } = res;
      if (code === '200') {
        const {
          chargeElectricToday, // 今日充电量
          pvEquipmentList, // 光伏设备列表
          stubGroupName, // 电站名称
          stubGroupAddress, // 电站地址
          pvStatusStr, // 光伏状态
          pvEquipmentPower, // 光伏功率
          pvEquipmentEfficiency, // 光伏设备实时效率
          pvElectricToday, // 今日光伏发电量
          pcsEquipmentList,
          stationStubStatus, // 电站状态
          plugFaultRate, // 充电桩故障率
          plugUseRate, // 充电桩使用率
          pvStatus, // 光伏设备状态
          fault,
          free,
          off,
          charging,
          esequipmentAirConditionerStatusStr, // 空调状态
          esequipmentFireControlStatusStr, // 消防状态
          esequipmentParallelOffStatusStr, // 并网状态
          esequipmentStatusStr, // 电站状态

        } = data;
        // console.log('-----------------', data);
        const totalStub = fault + free + off + charging;
        // 设备使用率
        const deviceUseRate = totalStub ? toDecimal((charging / totalStub), 2) : 0;
        // console.log('单场站数据', data);
        let mppts = [];
        let eboxQueryPcsRtDTOS = []; // 电站电流电压功率
        let electricCurrentTotal = 0; // 电流总和
        let voltageTotal = 0;
        let powerTotal = 0;

        pvEquipmentList.forEach((item) => {
          item.stubGroupName = stubGroupName;
          if (item.mppts.length > 0) {
            mppts = mppts.concat(item.mppts);
            electricCurrentTotal += item.mppts.reduce((prev, cur) => prev + Number(cur.current), 0);
            voltageTotal += item.mppts.reduce((prev, cur) => prev + Number(cur.voltage), 0);
          }
        });
        pcsEquipmentList.forEach((item) => {
          item.stubGroupName = stubGroupName;
          if (item.eboxQueryPcsRtDTOS.length > 0) {
            eboxQueryPcsRtDTOS = eboxQueryPcsRtDTOS.concat(item.eboxQueryPcsRtDTOS);
          }
        });
        powerTotal = electricCurrentTotal * voltageTotal;
        const pvStation = {
          pvStatusStr,
          stubGroupName,
          pvEquipmentPower,
          pvEquipmentEfficiency,
          pvElectricToday,
          electricCurrentTotal,
          voltageTotal,
          powerTotal,
          mppts,
          pcsEquipmentList,
          eboxQueryPcsRtDTOS,
          ...data,
        };
        context.commit(GET_PV_EQUIPMENT_LIST, pvEquipmentList);
        context.commit(GET_PV_STATION, pvStation);
        // 总览电站卡片数据派发
        context.commit(GET_OVERVIEW_CARD_DATA, {
          stubGroupId, // 电站id
          chargeElectricToday, // 今日充电量
          pvElectricToday, // 今日光伏发电量
          stubGroupName, // 电站名称
          stubGroupAddress, // 电站地址
        });
        // 充电电站卡片数据派发
        context.commit(GET_CHARGING_CARD_DATA, {
          stubGroupId, // 电站id
          stubGroupName, // 电站名称
          stationStubStatus, // 电站状态
          plugFaultRate, // 充电桩故障率
          plugUseRate: deviceUseRate, // 充电桩使用率
        });
        // 光伏电站卡片数据派发
        context.commit(GET_PV_CARD_DATA, {
          stubGroupName, // 电站名称
          pvStatus, // 光伏设备状态
          pvStatusStr, // 光伏状态 str
          pvEquipmentPower, // 光伏功率
          pvEquipmentEfficiency, // 光伏设备实时效率
        });
        // 储能电站卡片数据派发
        context.commit(GET_STORAGE_CARD_DATA, {
          stubGroupName, // 电站名称
          esequipmentAirConditionerStatusStr, // 空调状态
          esequipmentFireControlStatusStr, // 消防状态
          esequipmentParallelOffStatusStr, // 并网状态
          esequipmentStatusStr, // 电站状态
        });
      }
    },
    // 今日充电度数 单桩
    async screenTodatData (context, stubGroupId) {
      const res = await getYesterdayOrTodayCharging({
        stubGroupId,
      });
      const { code, data } = res;
      if (code === '200') {
        // console.log('----今日充电度数----', data);
        const {
          pvPowerGenerationF,
          pvPowerGenerationG,
          pvPowerGenerationJ,
          pvPowerGenerationP,
        } = data;
        const pvStationTodat = {
          pvPowerGenerationJ: Number(pvPowerGenerationJ),
          pvPowerGenerationF: Number(pvPowerGenerationF),
          pvPowerGenerationG: Number(pvPowerGenerationG),
          pvPowerGenerationP: Number(pvPowerGenerationP),
          pvPowerGenerationTotal: Number(pvPowerGenerationF) + Number(pvPowerGenerationG) + Number(pvPowerGenerationJ) + Number(pvPowerGenerationP),
          storedChargingAmountTotal: data.storedChargingAmountF + data.storedChargingAmountG + data.storedChargingAmountP + data.storedChargingAmountJ,
          storedDisChargingAmountTotal: data.storedDisChargingAmountF + data.storedDisChargingAmountG + data.storedDisChargingAmountP + data.storedDisChargingAmountJ,
          ...data,
        };
        context.commit(GET_PV_STATION_TODAT, pvStationTodat);
      }
    },
    // 单个总累计充电量
    async screenDataStatistics (context, stubGroupId) {
      const res = await getPowerStatData({
        stubGroupId,
      });
      const { code, data } = res;
      if (code === '200' && data) {
        Object.keys(data).forEach((v) => {
          data[v] = Number(data[v]);
          if (v === 'pvPowerGeneration') {
            if (data[v] > 1000) {
              data[v] = toDecimal(data[v] / 1000, 1);
            }
          }
        });
        context.commit(GET_DATA_STATITISTICS, data);
      }
    },
  },

  getters: {
    powerStatData: (state) => state.powerStatData,
    pvStats: (state) => state.pvStats,
    monthAnysDate: (state) => state.monthAnysDate,
    monthPvPowerData: (state) => state.monthPvPowerData,
    totalPvPower: (state) => state.totalPvPower,
    monthChargingPowerData: (state) => state.monthChargingPowerData,
    monthDisChargingPowerData: (state) => state.monthDisChargingPowerData,
    pvPowerGeneration: (state) => state.pvPowerGeneration,
    pvEquipmentList: (state) => state.pvEquipmentList,
    pvStation: (state) => state.pvStation,
    pvStationTodat: (state) => state.pvStationTodat,
    dataStatistics: (state) => state.dataStatistics,
    chargingInfo: (state) => state.chargingInfo,
    overViewCardData: (state) => state.overViewCardData, // 总览电站卡片数据
    chargingCardData: (state) => state.chargingCardData, // 充电电站卡片数据
    pvCardData: (state) => state.pvCardData, // 光伏电站卡片数据
    storageCardData: (state) => state.storageCardData, // 储能电站卡片数据
    stationTableData: (state) => state.stationTableData, // 电站滚动列表数据
  },
};

export default overView;
